import { render } from "./TerminalManagement.vue?vue&type=template&id=83ce970c"
import script from "./TerminalManagement.vue?vue&type=script&lang=js"
export * from "./TerminalManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__